import { LocationType } from '../types';

export const SurfaceAreas: Record<LocationType, Record<string, number>> = {
  [LocationType.REGION]: {
    antarctic: 12397617,
    'arab states': 3516380,
    'central america and the caribbean': 2701425,
    'central and western asia': 5250999,
    'eastern asia': 11558035,
    'eastern europe': 18721142,
    'north america': 21542573,
    'northern africa': 7623590,
    'northern europe': 1792084,
    'pacific islands': 8496789,
    'south america': 183325,
    'south-eastern asia': 4418853,
    'southern america': 17508055,
    'southern asia': 6738359,
    'southern europe': 1309411,
    'sub-saharan africa': 22283427,
    'western europe': 1100416,
  },
  [LocationType.COUNTRY]: {
    afghanistan: 652255,
    albania: 29695,
    algeria: 2315445,
    angola: 1245286,
    antarctica: 12341081,
    argentina: 2784325,
    armenia: 28656,
    australia: 7687429,
    austria: 85064,
    azerbaijan: 91112,
    bangladesh: 133778,
    belarus: 208968,
    belgium: 30126,
    belize: 22045,
    benin: 116995,
    bhutan: 39377,
    bolivia: 1085227,
    'bosnia and herzegovina': 50605,
    botswana: 591840,
    brazil: 8508053,
    brunei: 10700,
    bulgaria: 110215,
    'burkina faso': 271588,
    burundi: 26239,
    cambodia: 182227,
    cameroon: 460309,
    canada: 10034787,
    'central african republic': 621847,
    chad: 1271363,
    chile: 814818,
    china: 9409432,
    colombia: 1151839,
    'costa rica': 53832,
    croatia: 57530,
    cuba: 114864,
    cyprus: 6207,
    'czech republic': 81207,
    'democratic republic of the congo': 2323424,
    denmark: 42759,
    djibouti: 21880,
    'dominican republic': 48157,
    'east timor': 14715,
    ecuador: 250740,
    egypt: 996053,
    'el salvador': 20893,
    england: 249982,
    'equatorial guinea': 27119,
    eritrea: 119316,
    estonia: 44678,
    ethiopia: 1132231,
    'falkland islands': 16363,
    fiji: 19290,
    finland: 341231,
    france: 644890,
    'french southern and antarctic lands': 11602,
    gabon: 269467,
    gambia: 14031,
    georgia: 69047,
    germany: 357425,
    ghana: 243462,
    greece: 131963,
    greenland: 2206584,
    guatemala: 109457,
    guinea: 239563,
    'guinea bissau': 36191,
    guyana: 209798,
    haiti: 28540,
    honduras: 113789,
    hungary: 92475,
    iceland: 107732,
    india: 3142743,
    indonesia: 1819136,
    iran: 1617493,
    iraq: 436933,
    ireland: 58455,
    israel: 22976,
    italy: 315099,
    'ivory coast': 329818,
    jamaica: 12460,
    japan: 404607,
    jordan: 89203,
    kazakhstan: 2729714,
    kenya: 590734,
    kosovo: 11230,
    kuwait: 16652,
    kyrgyzstan: 195868,
    laos: 229071,
    latvia: 63923,
    lebanon: 10099,
    lesotho: 27505,
    liberia: 98205,
    libya: 1633420,
    lithuania: 63830,
    luxembourg: 2417,
    macedonia: 25062,
    madagascar: 589363,
    malawi: 111193,
    malaysia: 338218,
    mali: 1235293,
    mauritania: 1053684,
    mexico: 1969408,
    moldova: 32320,
    mongolia: 1544268,
    montenegro: 13444,
    morocco: 591694,
    mozambique: 810938,
    myanmar: 679554,
    namibia: 824697,
    nepal: 150703,
    netherlands: 40023,
    'new caledonia': 23219,
    'new zealand': 277623,
    nicaragua: 129539,
    niger: 1182123,
    nigeria: 905046,
    'north korea': 125677,
    'northern cyprus': 3786,
    norway: 397969,
    oman: 309289,
    pakistan: 874078,
    panama: 75265,
    'papua new guinea': 464452,
    paraguay: 401316,
    peru: 1309622,
    philippines: 292250,
    poland: 310397,
    portugal: 93408,
    'puerto rico': 9225,
    qatar: 11328,
    'republic of serbia': 76388,
    'republic of the congo': 339672,
    romania: 238352,
    russia: 16987680,
    rwanda: 23365,
    'saudi arabia': 1920145,
    senegal: 194385,
    'sierra leone': 75979,
    slovakia: 47068,
    slovenia: 19118,
    'solomon islands': 24728,
    somalia: 484230,
    somaliland: 167334,
    'south africa': 1216300,
    'south korea': 99042,
    'south sudan': 624895,
    spain: 502291,
    'sri lanka': 65367,
    sudan: 1850526,
    suriname: 144265,
    swaziland: 18118,
    sweden: 450562,
    switzerland: 46185,
    syria: 184995,
    taiwan: 34344,
    tajikistan: 138108,
    thailand: 510113,
    'the bahamas': 15585,
    togo: 60964,
    'trinidad and tobago': 7738,
    tunisia: 156234,
    turkey: 798821,
    turkmenistan: 480797,
    uganda: 245758,
    ukraine: 601919,
    'united arab emirates': 79871,
    tanzania: 932636,
    uruguay: 176849,
    usa: 9510025,
    uzbekistan: 461324,
    vanuatu: 7490,
    venezuela: 908478,
    vietnam: 335982,
    'west bank': 5037,
    'western sahara': 96250,
    yemen: 455887,
    zambia: 751862,
    zimbabwe: 376317,
    'american samoa': 199,
    'antigua and barbuda': 442,
    barbados: 430,
    bermuda: 54,
    'british indian ocean territory': 60,
    'cape verde': 4033,
    'cayman islands': 264,
    congo: 342000,
    'cook islands': 236,
    curacao: 444,
    dominica: 751,
    'french polynesia': 4167,
    grenada: 344,
    'guinea-bissau': 36125,
    guam: 549,
    liechtenstein: 160,
    macao: 33,
    malta: 316,
    'marshall islands': 181,
    martinique: 1128,
    mayotte: 374,
    micronesia: 702,
    'midway islands': 6,
    montserrat: 102,
    nauru: 21,
    niue: 260,
    'norfolk island': 35,
    reunion: 2512,
    'saint barthelemy': 25,
    'saint helena': 394,
    'saint lucia': 616,
    'saint martin': 54,
    'saint pierre and miquelon': 242,
    samoa: 2831,
    svalbard: 61022,
    tokelau: 12,
    tuvalu: 26,
    'vatican city': 0.44,
    'aland islands': 1581,
    'congo - republic of the congo': 342000,
    'hong kong': 1114,
    'virgin islands (us)': 347,
    'sint maarten': 34,
    singapore: 740,
    kiribati: 811,
    monaco: 2.0,
    gibraltar: 6.8,
    'saint vincent and the grenadines': 389,
    'bonaire, saint eustatius and saba': 322,
    'sao tome and principe': 964,
    seychelles: 457,
    aruba: 180,
    bahrain: 778,
    anguilla: 91,
    mauritius: 2096,
    'faroe islands': 1393,
    maldives: 300,
    'christmas island': 135,
    tonga: 747,
    'united kingdom': 244376,
    'virgin islands (uk)': 151,
    'isle of man': 572,
    'congo - democratic republic of the congo': 2344858,
    'san marino': 61,
    'northern mariana islands': 457,
    guernsey: 78,
    jersey: 116,
    'saint kitts and nevis': 261,
    serbia: 88499,
    palau: 459,
    palestine: 6020,
    bahamas: 13880,
    andorra: 468,
    'french guiana': 83534,
    'turks and caicos islands': 948,
    comoros: 1861,
    guadeloupe: 1628,
    'united states': 9_525_067,
    'wallis and futuna': 142,
    'cocos (keeling) islands': 14,
    'french southern territories': 7_747,
  },
  [LocationType.METRO_AREA]: {
    '1': 7025,
    '10': 15808,
    '100': 3072,
    '101': 1861804,
    '102': 904341,
    '103': 94583,
    '104': 4256,
    '105': 5075,
    '106': 6757,
    '107': 37432,
    '108': 3125,
    '109': 4020,
    '11': 18916,
    '110': 3625,
    '111': 10422,
    '112': 9239228,
    '113': 3409,
    '114': 899,
    '115': 11491,
    '116': 1618,
    '117': 15785,
    '118': 4280,
    '119': 32194,
    '12': 557110,
    '120': 11176,
    '121': 5121,
    '122': 774,
    '123': 16915239,
    '124': 6424,
    '125': 136812,
    '126': 5224,
    '127': 1556,
    '128': 3663,
    '129': 1059,
    '13': 2701,
    '130': 911025,
    '131': 862194,
    '132': 5866,
    '133': 4155,
    '134': 845,
    '135': 10687,
    '136': 140270,
    '137': 6398,
    '138': 1273,
    '139': 19202,
    '14': 17891,
    '140': 4541,
    '141': 376881,
    '142': 61191,
    '143': 1685,
    '144': 12054,
    '145': 2627,
    '146': 1580,
    '147': 5261,
    '148': 6588,
    '149': 9277,
    '15': 8096,
    '150': 1341,
    '151': 3135,
    '153': 236058,
    '154': 7566,
    '155': 21142,
    '156': 5763,
    '157': 11203,
    '158': 13737,
    '159': 3866,
    '16': 12358,
    '160': 1078,
    '161': 633,
    '162': 128401,
    '163': 17559,
    '164': 331374,
    '165': 299792,
    '166': 589432,
    '167': 4619,
    '168': 1781,
    '169': 6561,
    '17': 6662,
    '170': 976,
    '171': 1925,
    '172': 883,
    '173': 26498,
    '174': 3955,
    '175': 127434,
    '176': 1122,
    '177': 22031,
    '178': 7615,
    '18': 9971,
    '180': 909,
    '181': 282337,
    '182': 9630,
    '183': 264327,
    '184': 411663,
    '185': 2575,
    '186': 1706,
    '187': 132024,
    '188': 3370,
    '189': 7822,
    '19': 9848171,
    '190': 777,
    '191': 5208,
    '192': 995,
    '193': 4212,
    '194': 95536,
    '195': 866,
    '196': 2109,
    '197': 950,
    '199': 92530,
    '2': 23845,
    '20': 2160,
    '200': 3537,
    '201': 86717,
    '202': 4748,
    '203': 347596,
    '204': 2370,
    '205': 4597,
    '206': 3320,
    '207': 1732,
    '208': 108233,
    '209': 3004,
    '21': 4349,
    '210': 1512,
    '211': 2031,
    '212': 464,
    '213': 6371,
    '214': 642,
    '215': 1923,
    '216': 3228,
    '217': 13458,
    '218': 1202,
    '219': 3393,
    '22': 7880,
    '220': 1736,
    '221': 81194,
    '222': 74313,
    '223': 146032,
    '224': 6070,
    '225': 320883,
    '226': 17365,
    '227': 154240,
    '228': 2304537,
    '229': 1139,
    '23': 2107,
    '231': 2112,
    '232': 16388,
    '233': 585215,
    '234': 190563,
    '235': 1398,
    '236': 204177,
    '237': 2519,
    '238': 7223,
    '239': 2606,
    '24': 12920,
    '240': 5274,
    '241': 252676,
    '242': 13980,
    '243': 1836,
    '244': 69460,
    '245': 856,
    '246': 19270,
    '247': 63356,
    '248': 10324,
    '249': 6956,
    '25': 1816563,
    '250': 765,
    '251': 1849,
    '252': 1280,
    '253': 857,
    '254': 2285,
    '255': 13940,
    '256': 1127,
    '257': 3408,
    '258': 130295,
    '259': 323,
    '26': 14707,
    '260': 416,
    '261': 703,
    '262': 180,
    '263': 10225,
    '264': 13683,
    '265': 1591,
    '266': 2517,
    '267': 1473,
    '268': 1000,
    '269': 3841,
    '27': 5441,
    '270': 850,
    '271': 954,
    '272': 2005,
    '273': 236918,
    '274': 99731,
    '275': 565,
    '276': 3756,
    '277': 4682,
    '278': 2556,
    '279': 1180,
    '28': 18678,
    '280': 1260,
    '281': 508179,
    '282': 4125,
    '283': 1428,
    '284': 3276,
    '285': 4404,
    '286': 10948,
    '287': 1617611,
    '288': 205,
    '289': 915,
    '29': 1802,
    '290': 2878,
    '291': 2088,
    '292': 129806,
    '293': 779,
    '294': 1106,
    '295': 1380,
    '296': 8732,
    '297': 2254,
    '298': 1227,
    '299': 11765,
    '3': 19042,
    '30': 29331,
    '300': 104237,
    '301': 1960,
    '302': 90799,
    '303': 86608,
    '304': 8660,
    '305': 5713,
    '306': 109189,
    '307': 85010,
    '308': 4118,
    '309': 2646,
    '31': 12630,
    '310': 2061,
    '311': 12753,
    '312': 1855,
    '313': 785,
    '314': 2280,
    '315': 2725868,
    '316': 81038,
    '317': 46364,
    '318': 23964,
    '319': 1781,
    '32': 5152,
    '320': 1882,
    '321': 1751,
    '322': 1822,
    '323': 4914,
    '324': 18498,
    '325': 798,
    '326': 6101,
    '327': 23805,
    '328': 1034,
    '329': 616,
    '33': 4821,
    '330': 10470,
    '331': 4182,
    '332': 1966,
    '333': 641831,
    '334': 3943,
    '335': 389209,
    '336': 1522,
    '337': 1521,
    '338': 731,
    '339': 1831,
    '34': 7633969,
    '340': 1632,
    '341': 1999,
    '342': 823,
    '343': 380748,
    '344': 2619,
    '345': 7365,
    '346': 2242,
    '347': 351,
    '348': 582,
    '349': 802,
    '35': 3107,
    '350': 1108,
    '351': 87514,
    '352': 1197,
    '353': 3140,
    '354': 233622,
    '355': 841,
    '356': 38687,
    '357': 105237,
    '358': 1501,
    '359': 1013,
    '36': 1918841,
    '360': 939217,
    '361': 229709,
    '362': 1062,
    '363': 5057,
    '364': 70416,
    '365': 62180,
    '366': 1081,
    '367': 9058,
    '368': 6826,
    '369': 10915,
    '37': 1545,
    '370': 2356,
    '371': 667094,
    '372': 6064,
    '373': 197368,
    '374': 2515,
    '375': 444,
    '376': 6531,
    '377': 539,
    '378': 643,
    '379': 1687,
    '38': 21765,
    '380': 292,
    '381': 1083017,
    '382': 187687,
    '383': 2452,
    '384': 6391,
    '385': 6410,
    '386': 3092,
    '387': 60663,
    '388': 956,
    '389': 601,
    '39': 2770674,
    '390': 925,
    '391': 1629,
    '392': 3276,
    '393': 13709,
    '394': 749,
    '395': 2624,
    '396': 10297,
    '397': 3648,
    '398': 1080,
    '399': 115294,
    '4': 3097573,
    '40': 1125334,
    '400': 357,
    '401': 754,
    '402': 110621,
    '403': 1132,
    '404': 1194,
    '405': 109451,
    '406': 2105,
    '407': 183117,
    '408': 1511,
    '409': 13859,
    '41': 2624,
    '410': 24957,
    '411': 22866,
    '412': 1059,
    '413': 35845,
    '415': 9429,
    '416': 2680,
    '417': 797,
    '419': 399472,
    '420': 1103,
    '421': 11960,
    '422': 1023,
    '423': 5538,
    '424': 758,
    '425': 4247,
    '426': 5525,
    '427': 3693,
    '428': 2584,
    '429': 464078,
    '43': 473857,
    '430': 2454,
    '431': 616,
    '432': 51308,
    '433': 281,
    '434': 20269,
    '435': 234078,
    '436': 134622,
    '437': 46973,
    '438': 4455,
    '439': 4408,
    '44': 303093,
    '440': 1582,
    '441': 874,
    '442': 2003,
    '443': 2053,
    '444': 1359,
    '445': 3914,
    '446': 2763,
    '447': 1040,
    '448': 3264,
    '449': 199800,
    '45': 1995,
    '450': 217,
    '451': 2270,
    '452': 14362,
    '453': 64588,
    '454': 3697,
    '455': 828,
    '456': 481,
    '457': 5160,
    '458': 87832,
    '459': 40978,
    '46': 6814,
    '460': 177752,
    '461': 1125,
    '462': 609,
    '463': 177011,
    '464': 2722,
    '465': 14447,
    '466': 10113,
    '467': 2859,
    '468': 253329,
    '469': 578164,
    '47': 2877,
    '470': 2859,
    '471': 87628,
    '472': 1499,
    '473': 240320,
    '474': 279045,
    '475': 615,
    '476': 2208,
    '477': 1501,
    '478': 308128,
    '479': 60670,
    '48': 9287,
    '480': 148743,
    '481': 5176,
    '482': 187573,
    '483': 730,
    '484': 1672,
    '485': 28677,
    '486': 1063,
    '487': 21999,
    '488': 1835,
    '489': 2493,
    '49': 711,
    '490': 1168,
    '491': 295,
    '492': 486,
    '493': 13906,
    '494': 342,
    '495': 102492,
    '496': 5028,
    '497': 738,
    '498': 2035,
    '499': 2160,
    '5': 6120,
    '50': 560,
    '500': 1997,
    '501': 591,
    '502': 3291,
    '503': 621,
    '504': 4012,
    '505': 280,
    '506': 441,
    '507': 460762,
    '509': 320708,
    '51': 37808,
    '510': 189172,
    '511': 307,
    '512': 492,
    '514': 569,
    '515': 328,
    '516': 312,
    '517': 285,
    '518': 1553,
    '519': 49524,
    '52': 1819,
    '520': 1434,
    '521': 399,
    '522': 633236,
    '523': 2466,
    '524': 272458,
    '525': 1523429,
    '526': 2417,
    '527': 1128002,
    '528': 292,
    '529': 8895,
    '53': 285823,
    '530': 147090,
    '531': 434750,
    '532': 590565,
    '533': 511,
    '534': 15571,
    '535': 1845498,
    '536': 33854,
    '537': 196026,
    '538': 660,
    '539': 351,
    '54': 277493,
    '540': 1687,
    '541': 389,
    '542': 85010,
    '543': 27116,
    '544': 440,
    '545': 422,
    '546': 12719,
    '547': 3637,
    '548': 51227,
    '549': 653,
    '55': 17863,
    '550': 641,
    '551': 648,
    '552': 180792,
    '553': 12452,
    '554': 823889,
    '555': 703,
    '556': 4046,
    '557': 25437,
    '558': 1245064,
    '559': 109721,
    '56': 12106,
    '560': 206033,
    '561': 158,
    '562': 334,
    '563': 481,
    '564': 25279,
    '566': 513,
    '567': 21144,
    '568': 14279,
    '569': 2,
    '57': 2629,
    '570': 1235,
    '571': 785276,
    '572': 2446,
    '573': 563,
    '574': 750419,
    '575': 4087,
    '576': 118679,
    '578': 495,
    '579': 1700,
    '58': 4784,
    '580': 2673,
    '581': 127562,
    '582': 1353,
    '583': 451,
    '584': 344024,
    '586': 10536,
    '587': 10904,
    '588': 435,
    '589': 1637,
    '59': 10163,
    '590': 448981,
    '591': 510,
    '592': 598,
    '593': 1254968,
    '594': 669,
    '595': 339,
    '596': 372,
    '597': 18599,
    '598': 453277,
    '599': 1086,
    '6': 8432323,
    '60': 5550,
    '600': 626,
    '601': 801,
    '602': 251,
    '603': 1616944,
    '604': 68210,
    '605': 2032,
    '606': 262841,
    '607': 6163,
    '608': 1429,
    '609': 3214,
    '61': 2021,
    '610': 2078,
    '611': 316,
    '612': 2426,
    '613': 454,
    '614': 12888,
    '615': 603,
    '617': 5892,
    '618': 32179,
    '619': 251,
    '62': 554317,
    '620': 3215,
    '621': 95826,
    '622': 1567,
    '623': 76259,
    '624': 3276,
    '625': 273,
    '626': 56667,
    '627': 244595,
    '628': 382,
    '629': 279,
    '63': 11029,
    '630': 238,
    '631': 368,
    '632': 1017,
    '633': 13906,
    '634': 340,
    '635': 72371,
    '636': 1142,
    '637': 167979,
    '638': 1463,
    '639': 1564887,
    '64': 1210649,
    '640': 1406,
    '641': 309,
    '642': 619,
    '643': 16960,
    '644': 146,
    '645': 2298,
    '646': 335,
    '647': 2021,
    '648': 229745,
    '649': 2327393,
    '65': 461,
    '650': 530,
    '651': 745,
    '652': 1481,
    '653': 926,
    '654': 532,
    '655': 198325,
    '656': 1117,
    '657': 210745,
    '658': 74133,
    '659': 5028,
    '66': 3019,
    '660': 2024,
    '662': 387,
    '663': 400,
    '665': 2605,
    '667': 491,
    '67': 12928,
    '670': 510,
    '671': 154,
    '672': 566,
    '673': 336,
    '674': 1269782,
    '675': 582,
    '677': 642459,
    '678': 22045,
    '679': 1915,
    '68': 4353,
    '681': 145784,
    '682': 1037627,
    '683': 10704,
    '684': 818,
    '685': 1545,
    '686': 1486,
    '687': 423,
    '688': 226,
    '689': 4067,
    '69': 1379,
    '690': 359,
    '694': 912,
    '695': 335,
    '697': 436,
    '698': 617,
    '699': 17362,
    '7': 5548,
    '70': 3176,
    '700': 1493,
    '701': 489247,
    '703': 1378,
    '704': 283,
    '705': 18726,
    '706': 412,
    '707': 1180800,
    '708': 162,
    '709': 21683,
    '71': 9065,
    '710': 30560,
    '712': 762,
    '713': 1841,
    '714': 141300,
    '715': 160,
    '716': 1057,
    '717': 1319,
    '718': 499,
    '719': 26836,
    '72': 104444,
    '720': 1210,
    '721': 1779,
    '722': 465,
    '723': 903,
    '724': 1995,
    '725': 1530,
    '726': 237,
    '727': 116,
    '728': 955,
    '729': 2893,
    '73': 774164,
    '730': 197,
    '731': 2155937,
    '732': 1010,
    '733': 1910,
    '734': 69353,
    '735': 926,
    '737': 1420,
    '738': 620096,
    '739': 273,
    '74': 8718,
    '740': 61,
    '741': 14938,
    '742': 38585,
    '743': 1509,
    '744': 26845,
    '745': 5627,
    '747': 1405,
    '748': 688,
    '749': 27994,
    '75': 436174,
    '751': 359,
    '752': 863,
    '753': 1531,
    '754': 12202,
    '755': 1600,
    '756': 447,
    '759': 36,
    '76': 6439,
    '761': 153,
    '762': 1112,
    '763': 1807,
    '765': 681,
    '766': 125,
    '767': 1669,
    '769': 2869,
    '77': 6165,
    '771': 9447,
    '772': 33647,
    '774': 1648,
    '775': 1225,
    '777': 603,
    '778': 23,
    '78': 20572,
    '780': 461,
    '781': 120418,
    '784': 990,
    '786': 11905,
    '787': 658,
    '79': 8612,
    '790': 148,
    '794': 924,
    '795': 270,
    '796': 121995,
    '797': 29,
    '798': 10595,
    '799': 12350365,
    '8': 684,
    '80': 5533,
    '800': 290,
    '801': 269134,
    '809': 5991,
    '81': 2115,
    '810': 1696,
    '813': 1375,
    '814': 1157,
    '816': 1474,
    '817': 2513,
    '818': 8679,
    '819': 1176,
    '82': 40878,
    '820': 590,
    '821': 2129,
    '823': 2753,
    '829': 1696,
    '83': 4630,
    '833': 4273,
    '835': 6121,
    '836': 2954,
    '837': 7573,
    '839': 520,
    '84': 3274,
    '841': 2138,
    '842': 418,
    '845': 4090,
    '849': 7497,
    '85': 735988,
    '851': 2112,
    '852': 190,
    '854': 1218,
    '856': 5,
    '858': 960,
    '86': 325852,
    '860': 579,
    '861': 1618,
    '862': 9286,
    '863': 15564,
    '864': 8382,
    '867': 4730,
    '868': 5619,
    '869': 380,
    '87': 976372,
    '870': 1732,
    '871': 272,
    '872': 2597,
    '874': 591,
    '875': 469,
    '877': 1300,
    '878': 666,
    '879': 1119,
    '88': 11372,
    '881': 1003,
    '882': 401,
    '883': 1553,
    '887': 29483,
    '888': 399,
    '89': 1074,
    '890': 1164,
    '891': 1691,
    '896': 1373,
    '897': 2024,
    '898': 515,
    '9': 2039,
    '90': 3328,
    '900': 2329,
    '901': 910,
    '903': 373,
    '904': 674,
    '905': 2108,
    '908': 2814,
    '909': 4277,
    '911': 1637,
    '912': 403,
    '913': 737,
    '916': 848,
    '917': 2504,
    '92': 10389,
    '920': 4243,
    '921': 3813,
    '922': 883,
    '923': 2420,
    '925': 600,
    '927': 108,
    '928': 745,
    '929': 541,
    '93': 1290080,
    '930': 431,
    '931': 474,
    '932': 271,
    '933': 1139,
    '934': 349,
    '935': 189,
    '936': 397,
    '937': 689,
    '938': 2911,
    '94': 5978,
    '940': 1917,
    '941': 896,
    '942': 878,
    '943': 3221,
    '944': 1541,
    '945': 107,
    '947': 1256,
    '948': 197,
    '949': 231,
    '95': 6921,
    '950': 1476,
    '953': 13746,
    '956': 2032,
    '957': 1059,
    '958': 1742,
    '959': 1113,
    '96': 8482,
    '960': 594,
    '961': 1559,
    '962': 883,
    '965': 3091,
    '967': 2525,
    '968': 1284,
    '969': 2613,
    '97': 2157,
    '970': 1616,
    '971': 1174,
    '972': 1001,
    '973': 2984,
    '974': 1888,
    '975': 3779,
    '976': 1229,
    '977': 1661,
    '978': 1200,
    '979': 2353,
    '98': 15820,
    '980': 3436,
    '981': 1229,
    '983': 2770,
    '984': 3442,
    '985': 2179,
    '986': 1792,
    '987': 2609,
    '988': 689,
    '989': 2801,
    '99': 126397,
    '990': 555,
  },
  [LocationType.STATE]: {
    '1513': 53336,
    '1482': 4527,
    '2203': 7226,
    '314': 16923,
    '1277': 53412,
    '2345': 13721,
    '984': 129887,
    '3027': 74604,
    '3667': 20213,
    '406': 1816,
    '923': 724,
    '3418': 1677,
    '3405': 20112,
    '2467': 154055,
    '774': 2244,
    '3125': 4133,
    '3417': 1729,
    '3425': 9069,
    '3093': 9377,
    '3050': 6665,
    '1193': 3686,
    '367': 12125,
    '121': 771,
    '1736': 27551,
    '2132': 2205,
    '450': 1481,
    '387': 3224,
    '174': 1402,
    '3423': 2966,
    '2078': 123464,
    '2301': 127809,
    '2415': 181052,
    '3635': 103681,
    '3701': 62734,
    '1846': 119028,
    '2047': 150981,
    '1990': 20906,
    '1333': 216446,
    '1043': 146797,
    '2221': 200336,
    '3675': 174907,
    '2236': 314912,
    '3426': 8870,
    '3180': 199729,
    '3387': 685315,
    '572': 409704,
    '108': 133779,
    '1097': 151852,
    '2533': 117346,
    '2079': 180553,
    '764': 269597,
    '3538': 219884,
    '3381': 109147,
    '3732': 253327,
    '2240': 126058,
    '1520': 213094,
    '114': 1505146,
    '2230': 286377,
    '1362': 145922,
    '3604': 24892,
    '2109': 380829,
    '1386': 145735,
    '3179': 80065,
    '2233': 24034,
    '216': 295237,
    '3676': 176,
    '950': 130,
    '2885': 317,
    '2235': 19611,
    '1982': 25868,
    '1904': 83634,
    '1266': 16576,
    '845': 5106,
    '1224': 542,
    '2891': 406,
    '2744': 2748,
    '1563': 104659,
    '2409': 106857,
    '3725': 145306,
    '2440': 251138,
    '2304': 183125,
    '217': 137718,
    '1379': 93716,
    '2065': 218539,
    '772': 12878,
    '2871': 44,
    '533': 380166,
    '620': 103572,
    '681': 97085,
    '731': 220324,
    '534': 829,
    '780': 165742,
    '785': 86893,
    '1046': 73437,
    '1470': 53051,
    '1713': 140728,
    '1717': 91773,
    '2032': 153123,
    '2074': 27845,
    '2229': 95804,
    '2758': 201122,
    '2906': 154340,
    '2937': 76147,
    '2971': 239853,
    '2975': 130886,
    '2985': 133698,
    '3410': 12986,
    '3488': 22156,
    '161': 25,
    '400': 39477,
    '558': 7010,
    '1312': 33133,
    '1859': 19724,
    '3784': 36370,
    '3302': 4385,
    '3075': 2807,
    '1837': 3705,
    '1646': 2055,
    '3764': 214,
    '1171': 2393,
    '913': 2681,
    '3541': 1560,
    '1038': 1553,
    '2476': 3412,
    '2309': 2904,
    '1093': 5140,
    '3185': 2929,
    '1050': 3541,
    '2299': 5046,
    '1800': 2282,
    '3803': 1856,
    '2238': 800482,
    '3613': 227058,
    '2685': 1727807,
    '3177': 983532,
    '3708': 2523563,
    '3362': 67591,
    '2356': 1346172,
    '261': 2358,
    '544': 4122,
    '604': 9611,
    '1850': 19187,
    '3525': 11983,
    '2909': 7164,
    '3263': 16415,
    '3505': 12655,
    '3649': 2602,
    '3617': 415,
    '1079': 81308,
    '2237': 214,
    '1048': 490,
    '2867': 41,
    '1131': 39907,
    '3639': 40093,
    '1170': 25120,
    '515': 32797,
    '2087': 28863,
    '2066': 39874,
    '2067': 175,
    '524': 80,
    '1037': 12951,
    '3668': 15299,
    '393': 3372,
    '625': 5270,
    '3400': 1787,
    '967': 207830,
    '737': 50945,
    '755': 54450,
    '1714': 136254,
    '2450': 52168,
    '3351': 37599,
    '3226': 24888,
    '1029': 25590,
    '1063': 1747,
    '630': 146697,
    '2329': 112672,
    '3606': 17379,
    '41': 16347,
    '3623': 24466,
    '2777': 9174,
    '2288': 36953,
    '2124': 14093,
    '3607': 33273,
    '2457': 450,
    '3477': 74079,
    '1383': 52067,
    '571': 7424,
    '807': 22377,
    '184': 63117,
    '246': 3325,
    '1898': 22582,
    '3572': 20345,
    '2979': 30524,
    '2210': 30266,
    '462': 1613,
    '622': 30694,
    '2925': 45,
    '1163': 1010,
    '138': 1565849,
    '2499': 1217769,
    '1959': 324598,
    '626': 148115,
    '2756': 51671,
    '2502': 55823,
    '2563': 251746,
    '2541': 96942,
    '109': 25358,
    '3047': 21426,
    '3429': 278115,
    '294': 562675,
    '1997': 905578,
    '1128': 340227,
    '1028': 5314,
    '2063': 590464,
    '1002': 46583,
    '1998': 354964,
    '2761': 42513,
    '2997': 247563,
    '2504': 196946,
    '2968': 93652,
    '2757': 267477,
    '1354': 12070,
    '663': 39530,
    '498': 48066,
    '2290': 30058,
    '1264': 32289,
    '1158': 58568,
    '2516': 32351,
    '521': 27333,
    '2364': 84688,
    '2215': 73278,
    '263': 71145,
    '2638': 31501,
    '786': 8690,
    '1257': 124943,
    '2284': 60584,
    '1858': 122667,
    '1605': 10722,
    '511': 6049,
    '2357': 12303,
    '258': 4798,
    '3663': 24458,
    '376': 12200,
    '1114': 8337,
    '1268': 14154,
    '3348': 7240,
    '1931': 22197,
    '3679': 8094,
    '3686': 23082,
    '592': 44933,
    '2461': 31846,
    '3220': 31504,
    '3361': 9622,
    '2226': 414,
    '1971': 10405,
    '391': 2781,
    '523': 528,
    '543': 7579,
    '1064': 2132,
    '2108': 3590,
    '2581': 4431,
    '2583': 5951,
    '2795': 2840,
    '3147': 7050,
    '3149': 1341,
    '3248': 5164,
    '3350': 2715,
    '3583': 3899,
    '3598': 4508,
    '667': 21776,
    '1263': 25534,
    '535': 112,
    '3000': 223,
    '2619': 98,
    '2555': 682,
    '368': 12138,
    '662': 68377,
    '1021': 34390,
    '2293': 66901,
    '2330': 17108,
    '22': 61915,
    '928': 109198,
    '3172': 47280,
    '3201': 24590,
    '3680': 14024,
    '1812': 20345,
    '2241': 402897,
    '2632': 5637,
    '2366': 54908,
    '2232': 72597,
    '2683': 1506434,
    '2425': 988859,
    '1946': 649497,
    '3007': 652221,
    '116': 663243,
    '520': 944637,
    '3775': 483598,
    '2359': 1347021,
    '2381': 2075722,
    '1279': 2671,
    '1179': 10128,
    '110': 9743,
    '2929': 4960,
    '2653': 11304,
    '607': 3067,
    '1801': 9102,
    '7': 2135,
    '3751': 2068,
    '1127': 15675,
    '3008': 23878,
    '3015': 40063,
    '3573': 28267,
    '768': 13896,
    '2456': 4077,
    '3129': 2074,
    '3120': 4509,
    '444': 2642,
    '2019': 721,
    '1637': 1805,
    '3580': 1271,
    '749': 643,
    '3783': 3069,
    '1407': 2839,
    '2631': 3508,
    '3089': 2924,
    '3224': 4478,
    '918': 1767,
    '1265': 732,
    '1996': 11655,
    '1299': 9139,
    '3626': 8170,
    '2201': 26583,
    '331': 231,
    '2171': 375,
    '185': 126360,
    '215': 16898,
    '242': 76343,
    '270': 101181,
    '777': 40810,
    '205': 31845,
    '1838': 47500,
    '1840': 18545,
    '2372': 13168,
    '3349': 42328,
    '3576': 16279,
    '431': 23926,
    '2389': 16641,
    '2001': 30571,
    '2982': 15844,
    '1227': 32191,
    '1182': 241402,
    '1054': 119321,
    '3776': 373241,
    '1198': 178470,
    '1455': 169748,
    '1320': 206335,
    '3808': 100019,
    '3064': 1734,
    '727': 81485,
    '1315': 186237,
    '3091': 493080,
    '169': 139000,
    '1454': 94549,
    '1275': 163572,
    '3407': 1127406,
    '3063': 145240,
    '2267': 49187,
    '3055': 199608,
    '3404': 11148,
    '3065': 154340,
    '385': 14810,
    '1080': 429607,
    '1271': 181084,
    '1786': 145238,
    '1459': 181473,
    '3739': 1590655,
    '1382': 1137708,
    '1272': 447503,
    '1652': 559,
    '1181': 170192,
    '1757': 996,
    '1798': 1247,
    '2480': 1400,
    '2259': 2714,
    '144': 1924,
    '1570': 682,
    '1291': 496,
    '639': 10930,
    '1457': 10057,
    '2584': 7651,
    '1535': 3310,
    '3536': 5344,
    '1789': 3164,
    '1655': 4761,
    '2505': 4520,
    '3659': 6796,
    '3192': 7186,
    '2418': 5272,
    '2121': 5433,
    '3816': 3963,
    '646': 12608,
    '3802': 6633,
    '595': 2450,
    '3181': 11112,
    '885': 6746,
    '2838': 55,
    '1707': 2923,
    '2647': 1732,
    '2926': 1172,
    '2987': 1233,
    '2175': 44,
    '2509': 29773,
    '602': 3629,
    '1828': 11113,
    '3790': 10369,
    '969': 5529,
    '1000': 14951,
    '1367': 4812,
    '3269': 17821,
    '2974': 3779,
    '2988': 4125,
    '2564': 9704,
    '1926': 19298,
    '275': 8004,
    '580': 3210,
    '1191': 15095,
    '1839': 7251,
    '790': 5957,
    '470': 3898,
    '3496': 3397,
    '710': 6467,
    '2206': 12694,
    '2442': 21410,
    '2323': 27606,
    '3197': 29037,
    '240': 58500,
    '2728': 102475,
    '1999': 154021,
    '120': 2581,
    '1402': 4324,
    '3276': 9024,
    '1103': 1845,
    '1016': 5688,
    '402': 11006,
    '2068': 29105,
    '241': 13935,
    '3150': 10173,
    '2667': 1890,
    '1117': 38185,
    '2115': 2063,
    '384': 10978,
    '565': 3002,
    '2662': 1178,
    '828': 1014,
    '1486': 4202,
    '2605': 1398,
    '3067': 4795,
    '1710': 1645,
    '2942': 2142,
    '2966': 2028,
    '2946': 900,
    '432': 610,
    '1810': 6989,
    '1894': 1238,
    '2479': 4794,
    '1332': 3353,
    '3355': 2995,
    '26': 553,
    '142': 155267,
    '1246': 363,
    '2449': 323157,
    '2802': 108365,
    '3156': 312704,
    '3411': 51728,
    '631': 4441,
    '3702': 5937,
    '3547': 9195,
    '3221': 9953,
    '3196': 19130,
    '2320': 20366,
    '1521': 5711,
    '2459': 19943,
    '2568': 14612,
    '3193': 13992,
    '650': 5168,
    '2483': 6941,
    '1754': 98894,
    '2317': 37285,
    '1491': 24449,
    '2311': 21594,
    '3009': 8158,
    '3187': 6872,
    '1697': 4819,
    '1965': 1136,
    '1006': 19510,
    '2405': 22063,
    '3703': 1751,
    '332': 52,
    '2298': 2176,
    '3343': 16157,
    '2446': 66083,
    '911': 86013,
    '3171': 53630,
    '608': 20287,
    '1974': 38991,
    '2697': 17628,
    '1033': 38861,
    '401': 27656,
    '559': 77780,
    '2197': 77852,
    '1940': 62817,
    '1953': 23299,
    '3146': 67938,
    '3385': 100748,
    '3787': 101818,
    '1685': 6567,
    '3304': 238,
    '14': 2969,
    '1368': 6469,
    '2918': 7407,
    '287': 36077,
    '373': 70525,
    '408': 892,
    '506': 29654,
    '514': 396,
    '1239': 734,
    '1282': 21118,
    '2017': 23013,
    '1853': 47604,
    '2319': 34457,
    '2743': 19852,
    '2806': 2569,
    '3020': 18446,
    '3021': 20547,
    '3025': 15510,
    '3403': 16203,
    '479': 23148,
    '3704': 13854,
    '945': 18680,
    '2337': 24582,
    '632': 10012,
    '3647': 10300,
    '3532': 19559,
    '3527': 8676,
    '1165': 3194,
    '795': 8247,
    '254': 3698,
    '649': 32936,
    '3693': 18625,
    '1385': 28795,
    '2296': 8510,
    '3398': 29342,
    '3048': 538806,
    '2825': 92,
    '3757': 0,
    '127': 10728,
    '3266': 2078,
    '714': 2356,
    '2814': 534,
    '1187': 2222,
    '1421': 7451,
    '2687': 2135,
    '998': 4783,
    '2639': 26075,
    '2640': 9594,
    '292': 20504,
    '2641': 21975,
    '1870': 19244,
    '3275': 19950,
    '769': 360,
    '439': 94,
    '851': 2057,
    '3526': 16080,
    '2470': 5009,
    '2283': 2085,
    '317': 1022,
    '1388': 1773,
    '195': 6233,
    '143': 8113,
    '3800': 4284,
    '3771': 7805,
    '2544': 6915,
    '3303': 6134,
    '1230': 6317,
    '489': 7095,
    '1283': 3559,
    '388': 5475,
    '803': 3956,
    '1438': 5704,
    '1629': 2197,
    '1213': 4086,
    '3584': 3538,
    '3785': 3920,
    '3608': 4542,
    '340': 4181,
    '3157': 5862,
    '3438': 3429,
    '285': 8027,
    '1030': 4541,
    '596': 967,
    '2333': 21554,
    '3173': 23379,
    '311': 5540,
    '3695': 19135,
    '335': 9259,
    '645': 33546,
    '3690': 37530,
    '647': 153227,
    '3186': 36991,
    '3691': 146290,
    '657': 59630,
    '1142': 11914,
    '2324': 14116,
    '3198': 45734,
    '3203': 35619,
    '3699': 16115,
    '13': 56404,
    '398': 20954,
    '1435': 49005,
    '1748': 33375,
    '2745': 88392,
    '3700': 42396,
    '3199': 85422,
    '2325': 71477,
    '942': 44921,
    '1922': 43668,
    '2315': 30031,
    '937': 47255,
    '329': 16566,
    '2498': 313061,
    '3696': 93320,
    '938': 125777,
    '2310': 70454,
    '3769': 3180,
    '1429': 639,
    '2012': 23741,
    '2313': 28657,
    '1568': 179207,
    '1969': 29067,
    '1569': 25382,
    '2666': 15555,
    '3792': 21753,
    '1395': 107172,
    '3682': 39907,
    '208': 17883,
    '1129': 20423,
    '2724': 118690,
    '3189': 149397,
    '3121': 178770,
    '3762': 73784,
    '1306': 69980,
    '1588': 63057,
    '3372': 13615,
    '2149': 3448,
    '149': 28307,
    '279': 7997,
    '290': 862,
    '362': 17375,
    '2266': 36941,
    '919': 7081,
    '2898': 26412,
    '1610': 10595,
    '206': 13550,
    '3280': 17096,
    '3519': 8169,
    '1769': 19766,
    '2154': 23598,
    '771': 18014,
    '2515': 124572,
    '3807': 144250,
    '2675': 196077,
    '1937': 155500,
    '1527': 427698,
    '2695': 224728,
    '939': 285270,
    '197': 299942,
    '256': 111057,
    '3084': 117398,
    '196': 146076,
    '2312': 97976,
    '124': 700,
    '369': 153308,
    '2382': 709,
    '3498': 63885,
    '3455': 2479,
    '3508': 3347,
    '1741': 9684,
    '2039': 6900,
    '2191': 7446,
    '1616': 2676,
    '2387': 3334,
    '1615': 1306,
    '1590': 2574,
    '1882': 6221,
    '1493': 21819,
    '2181': 705,
    '1600': 12493,
    '3322': 17144,
    '2095': 222,
    '1111': 12,
    '2658': 1762,
    '1078': 18929,
    '1210': 9976,
    '736': 7434,
    '1376': 307,
    '1446': 8208,
    '1447': 10245,
    '1212': 9736,
    '549': 226,
    '1211': 18579,
    '3046': 548,
    '817': 352,
    '3032': 7673,
    '1209': 124,
    '2635': 2291,
    '3644': 3482,
    '656': 2420,
    '985': 2,
    '3217': 20070,
    '3707': 671,
    '1792': 57926,
    '1051': 62470,
    '1766': 57842,
    '192': 73080,
    '3006': 49623,
    '3244': 601,
    '750': 1129,
    '2829': 1195,
    '1932': 854,
    '2452': 1854,
    '2412': 6297,
    '1325': 8314,
    '1056': 4180,
    '3072': 4017,
    '2207': 3691,
    '1109': 10622,
    '2056': 5719,
    '3665': 4688,
    '3434': 2053,
    '1057': 4919,
    '2892': 3798,
    '1058': 13770,
    '3430': 6408,
    '187': 9609,
    '2818': 2401,
    '2179': 3734,
    '2083': 7712,
    '1675': 7326,
    '1489': 8948,
    '1204': 6362,
    '1698': 4595,
    '705': 5083,
    '1329': 6080,
    '1510': 2378,
    '1290': 8322,
    '3448': 3503,
    '3073': 6693,
    '2263': 12556,
    '2178': 13555,
    '54': 5081,
    '3749': 4470,
    '2082': 7217,
    '3746': 9318,
    '70': 11581,
    '1414': 15255,
    '3451': 4250,
    '3078': 7698,
    '1396': 4128,
    '2413': 7007,
    '3433': 4097,
    '1624': 7077,
    '964': 5538,
    '1487': 1784,
    '2414': 2115,
    '1298': 78024,
    '3747': 5956,
    '437': 20192,
    '3618': 12716,
    '2753': 286,
    '414': 21,
    '1788': 1226,
    '2106': 1199,
    '3183': 932,
    '404': 1331,
    '1986': 4044,
    '2114': 1859,
    '2192': 66238,
    '2077': 50723,
    '3472': 2494,
    '328': 9583,
    '997': 10,
    '3022': 27,
    '3553': 17,
    '3628': 9830,
    '2495': 7876,
    '1547': 8079,
    '133': 5446,
    '1618': 4812,
    '3086': 8543,
    '2037': 224,
    '594': 199,
    '1875': 239,
    '870': 205,
    '996': 243,
    '2153': 2,
    '3516': 4766,
    '2586': 1467,
    '1150': 1788,
    '867': 19147,
    '3563': 17312,
    '251': 22702,
    '176': 29858,
    '460': 29024,
    '249': 66082,
    '3528': 21165,
    '653': 35556,
    '3219': 32949,
    '2353': 49962,
    '3033': 7699,
    '1465': 18945,
    '1670': 242,
    '2026': 1606,
    '2224': 6634,
    '2809': 73378,
    '3005': 123538,
    '1560': 14834,
    '2655': 48,
    '3382': 12830,
    '2482': 36093,
    '1556': 9396,
    '2539': 821,
    '2537': 20621,
    '2532': 1000,
    '1726': 79,
    '1919': 0,
    '322': 240,
    '1081': 178428,
    '3031': 61916,
    '2857': 2,
    '3358': 1,
    '3574': 1,
    '1706': 2,
    '1349': 6,
    '1907': 1,
    '825': 17007,
    '446': 255,
    '2091': 235,
    '2572': 198,
    '2604': 40,
    '299': 72592,
    '300': 71503,
    '576': 55349,
    '704': 72728,
    '708': 247452,
    '753': 151643,
    '759': 5755,
    '2044': 1495,
    '921': 123364,
    '1180': 30607,
    '1196': 63497,
    '1285': 20820,
    '1433': 78588,
    '2043': 22352,
    '2048': 58577,
    '2125': 4879,
    '2218': 27903,
    '2375': 64157,
    '2394': 92638,
    '2646': 34309,
    '2686': 11690,
    '2691': 43133,
    '2938': 61137,
    '3107': 55293,
    '3161': 180011,
    '3308': 24201,
    '3334': 77815,
    '3424': 3996,
    '3602': 70508,
    '3773': 39422,
    '3779': 75276,
    '2590': 331,
    '718': 576,
    '3458': 3340,
    '2760': 9302,
    '1927': 4102,
    '1776': 5491,
    '1152': 1929,
    '866': 99178,
    '77': 13028,
    '21': 46529,
    '2164': 4019,
    '3204': 37385,
    '19': 30730,
    '316': 347111,
    '3108': 136363,
    '272': 11892,
    '1589': 102722,
    '2651': 203655,
    '1399': 628,
    '1640': 43,
    '457': 4568,
    '762': 5101,
    '1281': 2332,
    '2493': 2944,
    '2492': 8203,
    '3603': 11164,
    '716': 6486,
    '756': 4880,
    '2214': 253,
    '3714': 4247,
    '770': 18551,
    '778': 4791,
    '555': 12904,
    '1408': 17100,
    '131': 14883,
    '633': 2411,
    '2652': 66890,
    '3493': 4486,
    '2570': 35424,
    '1745': 14101,
    '566': 33144,
    '140': 39025,
    '1711': 25247,
    '156': 35902,
    '2941': 51452,
    '1314': 37223,
    '2508': 24200,
    '1797': 32487,
    '1796': 2443,
    '3511': 105065,
    '1473': 44972,
    '1331': 20684,
    '1890': 84613,
    '810': 72294,
    '194': 21186,
    '267': 43592,
    '211': 63438,
    '2118': 15663,
    '3313': 15526,
    '1836': 373358,
    '262': 11868,
    '779': 18193,
    '2042': 595,
    '1364': 12162,
    '562': 26258,
    '648': 21204,
    '567': 16359,
    '2062': 25618,
    '3788': 14450,
    '415': 16983,
    '3720': 19501,
    '658': 13982,
    '958': 20140,
    '2347': 17472,
    '838': 18704,
    '3143': 17933,
    '599': 18457,
    '3264': 17850,
    '2587': 20272,
    '1819': 18219,
    '1855': 19946,
    '2427': 9411,
    '3300': 11709,
    '2013': 35559,
    '1166': 29825,
    '1781': 15182,
    '1864': 13990,
    '1672': 17972,
    '2598': 18158,
    '3698': 22365,
    '1862': 25149,
    '3672': 24012,
    '3102': 12332,
    '1886': 770,
    '265': 2792,
    '502': 2704,
    '503': 6595,
    '613': 6627,
    '1024': 4887,
    '1185': 5533,
    '1770': 3492,
    '1808': 2734,
    '2609': 2329,
    '2980': 6714,
    '879': 5047,
    '3610': 2215,
    '3637': 5010,
    '115': 6243,
    '200': 7819,
    '212': 6825,
    '284': 6621,
    '418': 7782,
    '441': 5354,
    '504': 4766,
    '508': 5364,
    '553': 6102,
    '600': 8530,
    '752': 6673,
    '773': 6916,
    '793': 3709,
    '827': 4072,
    '898': 7451,
    '1073': 4476,
    '1136': 5585,
    '1248': 6638,
    '1321': 7063,
    '1326': 4454,
    '1328': 5490,
    '1359': 1570,
    '1958': 6311,
    '2024': 4957,
    '529': 235,
    '2158': 6714,
    '2220': 5900,
    '2419': 5504,
    '2618': 4698,
    '2899': 3864,
    '3010': 4516,
    '3090': 5432,
    '3265': 8555,
    '3377': 5927,
    '3414': 8777,
    '3566': 5766,
    '3586': 5337,
    '3652': 4856,
    '129': 168041,
    '3491': 25720,
    '1577': 534861,
    '1661': 2322674,
    '3292': 194204,
    '3645': 112888,
    '1390': 774982,
    '2788': 100985,
    '2801': 39711,
    '1660': 7818,
    '2912': 53579,
    '3364': 68016,
    '3441': 314522,
    '1533': 183841,
    '218': 400296,
    '237': 50696,
    '392': 27160,
    '526': 34939,
    '697': 88638,
    '739': 18399,
    '3506': 159809,
    '2536': 43394,
    '2130': 2561,
    '2131': 44438,
    '2368': 55081,
    '2371': 177857,
    '2422': 141270,
    '2441': 24649,
    '2895': 79332,
    '2894': 3064924,
    '3004': 101197,
    '2735': 168635,
    '3504': 84477,
    '3512': 42145,
    '1501': 29806,
    '3520': 37222,
    '3646': 144310,
    '3758': 36179,
    '1413': 21658,
    '1561': 95812,
    '1573': 784721,
    '1498': 13434,
    '2630': 166020,
    '359': 142980,
    '1597': 730,
    '2349': 3273,
    '3487': 425,
    '2940': 7,
    '3442': 240,
    '791': 729,
    '2927': 23,
    '2606': 14,
    '3494': 524,
    '683': 59,
    '3497': 287,
    '424': 672,
    '1558': 5106,
    '3288': 2612,
    '2816': 7000,
    '1492': 6533,
    '1947': 1139,
    '2670': 22255,
    '3363': 38794,
    '2660': 7482,
    '336': 3592,
    '214': 456,
    '2174': 2824,
    '97': 1078,
    '1068': 7550,
    '1885': 9339,
    '233': 94316,
    '2999': 844,
    '954': 557807,
    '2182': 88411,
    '2341': 115729,
    '1217': 111825,
    '2772': 375554,
    '1': 77243,
    '2016': 137790,
    '3311': 137690,
    '2020': 146866,
    '106': 68306,
    '76': 10316,
    '1440': 15463,
    '87': 81844,
    '823': 532,
    '1522': 5263,
    '2888': 18966,
    '3399': 6575,
    '509': 2050,
    '3475': 4158,
    '3466': 4501,
    '2272': 6425,
    '3812': 6807,
    '333': 9484,
    '2626': 8974,
    '1641': 6828,
    '1963': 11553,
    '1656': 7311,
    '1302': 16,
    '325': 208,
    '3728': 28091,
    '2376': 27481,
    '374': 43938,
    '948': 168860,
    '2436': 129830,
    '1085': 18178,
    '1686': 93302,
    '1802': 125752,
    '2139': 76484,
    '2331': 104894,
    '2342': 374484,
    '3710': 129394,
    '642': 43045,
    '582': 7408,
    '2029': 14,
    '679': 20,
    '1718': 5045,
    '361': 7223,
    '2157': 11307,
    '1891': 8031,
    '1075': 29539,
    '1009': 41635,
    '3568': 23238,
    '619': 32092,
    '615': 79458,
    '614': 94224,
    '590': 5307,
    '310': 4872,
    '238': 10591,
    '202': 47722,
    '157': 87520,
    '2351': 8722,
    '956': 9711,
    '634': 5728,
    '2302': 10642,
    '2327': 8027,
    '2811': 4956,
    '3206': 5536,
    '3548': 8634,
    '3705': 3705,
    '2841': 26,
    '617': 93,
    '2840': 49,
    '88': 27128,
    '1579': 21216,
    '2729': 215545,
    '2503': 155,
    '1952': 4089,
    '1284': 3658,
    '3556': 22237,
    '3555': 59457,
    '1427': 54265,
    '1067': 19589,
    '826': 30740,
    '3533': 8227,
    '3557': 5607,
    '2391': 9581,
    '3554': 21697,
    '3558': 28707,
    '1235': 5812,
    '3124': 11302,
    '1667': 9397,
    '449': 3059,
    '1499': 11631,
    '1463': 11737,
    '3253': 6831,
    '2392': 12012,
    '3145': 7059,
    '2291': 105553,
    '1144': 3100,
    '5': 1404,
    '190': 243,
    '191': 173,
    '358': 517,
    '357': 37,
    '409': 5958,
    '1049': 1672,
    '1094': 281,
    '1122': 685,
    '1169': 7111,
    '1474': 839,
    '1866': 1493,
    '2228': 800,
    '2260': 276,
    '2396': 491,
    '3023': 302,
    '3026': 908,
    '3155': 790,
    '2834': 2023,
    '3402': 989,
    '3408': 2812,
    '3534': 1077,
    '3564': 5222,
    '3588': 3208,
    '3821': 239,
    '3823': 1729,
    '875': 117,
    '119': 19939,
    '1301': 42784,
    '1762': 2377,
    '3356': 1873,
    '3321': 2049,
    '3323': 269,
    '3326': 2961,
    '3277': 25549,
    '924': 364,
    '1601': 12423,
    '228': 38838,
    '2014': 61410,
    '2127': 70609,
    '894': 41239,
    '3796': 184,
    '2167': 24642,
    '3074': 16421,
    '680': 5501,
    '2187': 20733,
    '2552': 6228,
    '3284': 13365,
    '330': 1573,
    '1585': 10733,
    '2554': 10669,
    '703': 11412,
    '2185': 2088,
    '2280': 639,
    '2617': 6370,
    '3159': 7317,
    '2562': 495,
    '3454': 4696,
    '3109': 844,
    '2723': 3652,
    '2558': 2476,
    '2548': 3829,
    '2510': 1514,
    '1654': 4340,
    '726': 4378,
    '702': 22703,
    '2922': 837,
    '2921': 935,
    '1512': 19556,
    '874': 331,
    '1967': 6353,
    '2354': 85152,
    '957': 31846,
    '654': 69167,
    '3719': 56836,
    '583': 4514,
    '2113': 521,
    '1918': 4799,
    '1764': 10030,
    '2930': 4999,
    '3167': 9003,
    '763': 6108,
    '674': 13647,
    '2517': 14407,
    '2759': 9679,
    '160': 4206,
    '1031': 6697,
    '2913': 16547,
    '537': 39580,
    '2663': 28763,
    '3360': 345,
    '3069': 1242,
    '186': 46669,
    '203': 7118,
    '347': 36816,
    '471': 250482,
    '598': 5199,
    '1019': 28092,
    '1186': 64857,
    '3582': 1170,
    '1755': 19463,
    '2035': 11856,
    '2070': 8817,
    '2097': 27836,
    '2373': 986,
    '2611': 17427,
    '3268': 10832,
    '3312': 9959,
    '3479': 8346,
    '3755': 6081,
    '3822': 44522,
    '148': 3430,
    '276': 1656,
    '280': 3542,
    '283': 1029,
    '426': 5564,
    '427': 2371,
    '429': 8137,
    '578': 1784,
    '814': 853,
    '1060': 12918,
    '871': 9304,
    '904': 6019,
    '1108': 15935,
    '1215': 929,
    '1243': 3193,
    '1216': 5828,
    '1225': 2002,
    '1228': 950,
    '1292': 1984,
    '1322': 918,
    '1576': 4590,
    '1595': 5819,
    '1744': 9674,
    '2193': 1607,
    '2248': 16397,
    '2677': 10460,
    '2678': 4298,
    '2679': 4501,
    '3368': 4203,
    '3390': 1350,
    '3391': 3491,
    '3392': 10425,
    '3401': 4613,
    '3409': 2146,
    '3630': 1495,
    '947': 51656,
    '2332': 125038,
    '635': 110302,
    '3207': 68200,
    '1874': 23496,
    '776': 31113,
    '2338': 77562,
    '538': 546,
    '1245': 940,
    '1941': 35890,
    '1987': 28158,
    '1988': 32163,
    '1989': 57600,
    '1991': 56485,
    '1992': 75401,
    '2054': 49363,
    '135': 534,
    '27': 721,
    '20': 4000,
    '2421': 7903,
    '1582': 25596,
    '3648': 20155,
    '2771': 20107,
    '3810': 29888,
    '1596': 28234,
    '699': 31922,
    '3282': 23823,
    '1578': 31439,
    '1868': 26667,
    '903': 26532,
    '3797': 27093,
    '1877': 21829,
    '1412': 13916,
    '3457': 12784,
    '3383': 13835,
    '700': 8109,
    '2399': 32607,
    '2169': 23808,
    '796': 24835,
    '3632': 26509,
    '1583': 20619,
    '698': 20953,
    '2595': 28715,
    '886': 31913,
    '1612': 24568,
    '1696': 828,
    '3051': 874,
    '2335': 143,
    '3212': 479,
    '1928': 70,
    '2151': 58,
    '73': 4424,
    '75': 168,
    '1267': 83,
    '103': 2541,
    '307': 2446,
    '107': 3313,
    '306': 168,
    '11': 59216,
    '69': 234,
    '916': 3926,
    '1053': 1675,
    '1365': 2493,
    '3066': 2383,
    '1366': 730,
    '24': 13687,
    '28': 7435,
    '34': 13985,
    '137': 5632,
    '183': 20286,
    '268': 8080,
    '312': 14474,
    '172': 25648,
    '71': 7825,
    '366': 4566,
    '422': 4158,
    '546': 10789,
    '579': 9755,
    '788': 12528,
    '856': 11949,
    '883': 15156,
    '925': 2610,
    '962': 6252,
    '975': 9168,
    '994': 24973,
    '999': 13977,
    '1088': 6795,
    '1232': 7172,
    '1252': 5635,
    '1404': 8678,
    '1406': 5379,
    '1422': 11893,
    '1490': 14271,
    '1525': 4183,
    '1554': 17193,
    '1602': 1423,
    '1608': 6384,
    '1621': 3418,
    '1635': 40820,
    '1683': 11809,
    '1917': 12297,
    '1945': 13239,
    '1960': 8668,
    '2038': 16100,
    '2147': 12495,
    '2231': 5476,
    '2439': 5776,
    '2458': 3350,
    '2893': 4817,
    '2919': 9571,
    '3123': 28596,
    '3373': 6183,
    '3453': 4641,
    '3535': 5570,
    '3578': 20724,
    '3745': 784,
    '3817': 3174,
    '2962': 19323,
    '3211': 14496,
    '641': 1232,
    '1449': 544,
    '3374': 171,
    '1226': 849,
    '2344': 3441,
    '719': 28512,
    '863': 20310,
    '2710': 18491,
    '1553': 30260,
    '2217': 37999,
    '3753': 9693,
    '3062': 158070,
    '1902': 306926,
    '2177': 16588,
    '3543': 241054,
    '3337': 129777,
    '701': 135153,
    '1199': 183254,
    '847': 1485,
    '3100': 10595,
    '3473': 10787,
    '3685': 85698,
    '2400': 155290,
    '417': 94167,
    '2709': 343399,
    '3375': 112084,
    '159': 163007,
    '227': 81769,
    '2023': 22414,
    '1453': 79867,
    '235': 78823,
    '1944': 22358,
    '1537': 191698,
    '3545': 51679,
    '815': 585,
    '1887': 308216,
    '1125': 3603,
    '1565': 38644,
    '690': 115,
    '158': 6384,
    '1288': 55236,
    '1436': 42997,
    '2650': 50871,
    '1250': 44198,
    '483': 25216,
    '123': 26323,
    '1811': 90,
    '2469': 1336,
    '248': 2996,
    '2254': 473,
    '801': 20928,
    '1012': 7618,
    '2407': 16687,
    '2477': 27689,
    '3151': 30836,
    '3789': 34281,
    '1737': 3067,
    '72': 6777,
    '381': 9232,
    '2424': 15006,
    '848': 16765,
    '2769': 9938,
    '1692': 33532,
    '1625': 28873,
    '403': 30814,
    '486': 72160,
    '1546': 23982,
    '2577': 26028,
    '963': 19559,
    '1456': 23420,
    '154': 4832,
    '1519': 20244,
    '2213': 26265,
    '1555': 37024,
    '1370': 5103,
    '23': 38921,
    '3768': 45443,
    '6': 4807,
    '965': 5785,
    '2460': 8522,
    '371': 49584,
    '2262': 71103,
    '1484': 45067,
    '989': 7626,
    '3346': 58219,
    '960': 6476,
    '1087': 375,
    '3683': 5820,
    '824': 269170,
  },
  [LocationType.COUNTY]: {},
  // TODO: Add city surface areas when city polygons are finalized
  // Could be a Uint16Array[30500] to save memory
  [LocationType.CITY]: {},
};
